var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right py-1 pr-4",attrs:{"id":"lang-change"}},[_c('button',{staticClass:"btn btn-link px-2 py-1",class:{
      'text-secondary': _vm.$store.state.lang === 'ua',
      'text-ccc': _vm.$store.state.lang === 'ru',
    },on:{"click":function($event){return _vm.$store.commit('mergeStore', {lang: 'ua'})}}},[_vm._v(" Українська ")]),_vm._v(" | "),_c('button',{staticClass:"btn btn-link px-2 py-1",class:{
      'text-secondary': _vm.$store.state.lang === 'ru',
      'text-ccc': _vm.$store.state.lang === 'ua'
    },on:{"click":function($event){return _vm.$store.commit('mergeStore', {lang: 'ru'})}}},[_vm._v(" Русский ")])])}
var staticRenderFns = []

export { render, staticRenderFns }